
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[raffleKey]",
      function () {
        return require("private-next-pages/shop/[raffleKey].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[raffleKey]"])
      });
    }
  